// extracted by mini-css-extract-plugin
module.exports = {"card":"pE-z"};